export default "__VITE_ASSET__25663b99__"